/**
 * src/screens/placeholder.js
 *
 * Stub view for every sidebar item outside the Dashboard this slice — proves
 * routing + the back button work end-to-end without pretending those screens
 * are built yet.
 */

import { t } from '../i18n/t.js';

export function mountPlaceholder(container, label) {
  container.innerHTML = `
    <div class="empty-state">
      <strong>${escapeHtml(label)}</strong>
      <div>${t('common.comingSoon')}</div>
    </div>`;
}

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]));
}
